import { combineReducers } from "redux";

import settingsReducer from "./settings/reducer";
import locationsReducer from "./locations/reducer";
import popularLocationReducer from "./popularLocations/reducer";
import promoSliderReducer from "./promoSlider/reducer";
import itemsReducer from "./items/reducer";
import cartReducer from "./cart/reducer";
import totalReducer from "./total/reducer";
import couponReducer from "./coupon/reducer";
import userReducer from "./user/reducer";
import pagesReducer from "./pages/reducer";
import restaurantSearchReducer from "./searchRestaurants/reducer";
import addressesReducer from "./addresses/reducer";
import cardsReducer from "./cards/reducer";
import checkoutReducer from "./checkout/reducer";
import confirmCartReducer from "./confirmCart/reducer";
import ordersReducer from "./orders/reducer";
import paymentGatewayReducer from "./paymentgateways/reducer";
import notificationReducer from "./notification/reducer";
import restaurantReducer from "./restaurant/reducer";
import ratingReducer from "./rating/reducer";
import alertReducer from "./alert/reducer";

import languageReducer from "./languages/reducer";

import deliveryUserReducer from "./Delivery/user/reducer";
import deliveryOrdersReducer from "./Delivery/orders/reducer";
import deliverySingleOrderReducer from "./Delivery/singleorder/reducer";
import gpsLocationReducer from "./Delivery/gpslocation/reducer";
import acceptToDeliver from "./Delivery/deliveryprogress/reducer";

import helperReducer from "./helper/reducer";

import posUserReducer from "./POS/user/reducer";
import posPlatformReducer from "./POS/platform/reducer";
import posCartReducer from "./POS/cart/reducer";
import posOrdersReducer from "./POS/orders/reducer";
import posPrintersReducer from "./POS/printers/reducer";
import posTerminalReducer from "./POS/terminal/reducer";
import posCashRegisterReducer from "./POS/cashRegister/reducer";
import posInventoryReducer from "./POS/inventory/reducer";
import posTablesReducer from "./POS/tables/reducer";
import posDraftsReducer from "./POS/drafts/reducer";
import posQuickReducer from "./POS/quick/reducer";
import posRefundsReducer from "./POS/refunds/reducer";
import posCustomItemsReducer from "./POS/customItems/reducer";

export default combineReducers({
	settings: settingsReducer,
	locations: locationsReducer,
	popular_locations: popularLocationReducer,
	promo_slides: promoSliderReducer,
	items: itemsReducer,
	total: totalReducer,
	cart: cartReducer,
	coupon: couponReducer,
	user: userReducer,
	pages: pagesReducer,
	restaurants: restaurantSearchReducer,
	addresses: addressesReducer,
	cards: cardsReducer,
	checkout: checkoutReducer,
	confirmCart: confirmCartReducer,
	orders: ordersReducer,
	paymentgateways: paymentGatewayReducer,
	delivery_user: deliveryUserReducer,
	delivery_orders: deliveryOrdersReducer,
	single_delivery_order: deliverySingleOrderReducer,
	gps_location: gpsLocationReducer,
	accepted_order: acceptToDeliver,
	notification_token: notificationReducer,
	restaurant: restaurantReducer,
	languages: languageReducer,
	rating: ratingReducer,
	alert: alertReducer,
	helper: helperReducer,
	pos_user: posUserReducer,
	pos_platform: posPlatformReducer,
	pos_cart: posCartReducer,
	pos_orders: posOrdersReducer,
	pos_printers: posPrintersReducer,
	pos_terminal: posTerminalReducer,
	pos_cash_register: posCashRegisterReducer,
	pos_inventory: posInventoryReducer,
	pos_tables: posTablesReducer,
	pos_drafts: posDraftsReducer,
	pos_quick: posQuickReducer,
	pos_refunds: posRefundsReducer,
	pos_custom_items: posCustomItemsReducer,
});
